import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  titleBlock: {
    id: 'Home Banner',
    defaultMessage: 'Banner',
  },
  title: {
    id: 'title',
    defaultMessage: 'Title',
  },
  AltText: {
    id: 'Alt text',
    defaultMessage: 'Alt text',
  },
  image: {
    id: 'Image',
    defaultMessage: 'Image',
  },
  hideMobile: {
    id: 'hide_mobile',
    defaultMessage: 'Hide mobile',
  },
  LinkTo: {
    id: 'Link to',
    defaultMessage: 'Link to',
  },
  openLinkInNewTab: {
    id: 'Open in a new tab',
    defaultMessage: 'Open in a new tab',
  },
  linkSettings: {
    id: 'Link settings',
    defaultMessage: 'Link settings',
  },
  settings: {
    id: 'fieldset_settings',
    defaultMessage: 'Settings',
  },
  banner: {
    id: 'banner',
    defaultMessage: 'banner',
  },
  itens: {
    id: 'itens',
    defaultMessage: 'itens',
  },
  delaySlide: {
    id: 'Delay between slides (ms)',
    defaultMessage: 'Delay between slides (ms)',
  },
  autoplay: {
    id: 'Autoplay',
    defaultMessage: 'Autoplay',
  },
  ratio: {
    id: 'mpf_home_banner_ratio',
    defaultMessage: 'Proporção',
  },
  ratioHelp: {
    id: 'mpf_home_banner_ratio_help',
    defaultMessage:
      'Trava a altura do banner na proporção escolhida, recortando a imagem pelo centro. Em branco, o banner acompanha a altura natural da imagem (comportamento da capa).',
  },
  ratio165: {
    id: 'mpf_home_banner_ratio_16_5',
    defaultMessage: '16:5 (mais baixo)',
  },
  ratio163: {
    id: 'mpf_home_banner_ratio_16_3',
    defaultMessage: '16:3 (faixa fina)',
  },
});

const itemSchema = (props: { intl: IntlShape; activeObject: any }) => {
  const { intl } = props;

  return {
    title: props.intl.formatMessage(messages.banner),
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.image),
        fields: ['image', 'alt'],
      },
      {
        id: 'link_settings',
        title: intl.formatMessage(messages.LinkTo),
        fields: ['href', 'openLinkInNewTab'],
      },
    ],
    properties: {
      image: {
        title: intl.formatMessage(messages.image),
        widget: 'object_browser',
        mode: 'image',
        allowExternals: false,
        initialPath: '/',
      },
      alt: {
        title: intl.formatMessage(messages.AltText),
      },
      href: {
        title: intl.formatMessage(messages.LinkTo),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: [
          '@id',
          '@type',
          'Title',
          'Description',
          'image_field',
          'getRemoteUrl',
        ],
        allowExternals: true,
        initialPath: '/',
      },
      openLinkInNewTab: {
        title: intl.formatMessage(messages.openLinkInNewTab),
        type: 'boolean',
      },
    },
    required: ['image', 'alt'],
  };
};

export const homeBannerSchema = (props: {
  intl: IntlShape;
  activeObject: any;
  setActiveObject: any;
}) => {
  const { intl } = props;
  return {
    title: intl.formatMessage(messages.titleBlock),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['items'],
      },
      {
        id: 'options',
        title: intl.formatMessage(messages.settings),
        fields: ['ratio', 'delay', 'autoplay', 'hideMobile'],
      },
    ],
    properties: {
      items: {
        widget: 'object_list',
        title: props.intl.formatMessage(messages.itens),
        schema: itemSchema,
        activeObject: props.activeObject,
        setActiveObject: props.setActiveObject,
      },
      // As duas proporções da anotação do Figma para o banner da sub-home.
      // SEM `default` de propósito: o `applyBlockDefaults` do Volto preenche
      // defaults de schema em tempo de render, para TODOS os blocos deste
      // tipo — um default aqui mudaria também os banners já publicados na
      // capa, que hoje acompanham a altura natural da imagem.
      ratio: {
        title: intl.formatMessage(messages.ratio),
        description: intl.formatMessage(messages.ratioHelp),
        choices: [
          ['16:5', intl.formatMessage(messages.ratio165)],
          ['16:3', intl.formatMessage(messages.ratio163)],
        ],
      },
      delay: {
        title: intl.formatMessage(messages.delaySlide),
        type: 'number',
        default: 8000,
      },
      autoplay: {
        title: intl.formatMessage(messages.autoplay),
        type: 'boolean',
        default: true,
      },
      hideMobile: {
        title: intl.formatMessage(messages.hideMobile),
        type: 'boolean',
        default: false,
      },
    },
    required: [],
  };
};
